import dayjs from 'dayjs';
import { ColumnDef } from '@benzinga/table';

import { AmountBags } from './AmountBags';
import { formatTransaction } from './formatTransaction';
import { ChamberBadge, PartyBadge, fullStateName } from './memberBadges';
import { MemberHeadshotCell, TableLink, TxnSide } from './TableCells';

export const SecurityRecentColumnsDef = [
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      if (!data?.filer_info) return null;
      const { display_name, headshot } = data.filer_info;
      return <MemberHeadshotCell className="font-bold hover:text-bzblue-700" headshot={headshot} name={display_name} />;
    },
    field: 'filer_info.display_name',
    headerName: 'Name',
    height: 100,
    sortEnabled: true,
    valueGetter: ({ data }) => data?.filer_info?.display_name ?? '',
    width: 180,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <AmountBags amount={data.amount} transactionType={data.transaction_type} />,
    field: 'amount',
    headerName: 'Amount',
    sortEnabled: true,
    width: 140,
  },
  {
    cellClass: 'security-cell type',
    field: 'security',
    headerName: 'Type',
    sortEnabled: true,
    valueFormatter: ({ value }) =>
      value?.type ? value.type.charAt(0).toUpperCase() + value.type.slice(1).toLowerCase() : '',
    width: 90,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => (
      <TxnSide type={data.transaction_type}>{formatTransaction(data.transaction_type)}</TxnSide>
    ),
    field: 'transaction_type',
    headerName: 'Transaction',
    sortEnabled: true,
    width: 130,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <PartyBadge party={data.filer_info?.party} />,
    field: 'filer_info.party',
    headerName: 'Party',
    sortEnabled: true,
    valueGetter: ({ data }) => data?.filer_info?.party ?? '',
    width: 140,
  },
  {
    cellClass: 'security-cell capitalize',
    cellRenderer: ({ data }) => fullStateName(data.filer_info?.state),
    field: 'filer_info.state',
    headerName: 'State',
    sortEnabled: true,
    valueGetter: ({ data }) => fullStateName(data?.filer_info?.state),
    width: 150,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => (
      <TableLink external href={data.disclosure_url}>
        {dayjs(data.report_date).format('MMM DD, YYYY')}
      </TableLink>
    ),
    field: 'report_date',
    headerName: 'Report Date',
    sortEnabled: true,
    width: 120,
  },
  {
    cellClass: 'security-cell',
    field: 'transaction_date',
    headerName: 'Trade Date',
    sortEnabled: true,
    valueFormatter: ({ value }) => dayjs(value).format('MMM DD, YYYY'),
    width: 120,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <ChamberBadge chamber={data.chamber} />,
    field: 'chamber',
    headerName: 'Chamber',
    sortEnabled: true,
    width: 110,
  },
] as ColumnDef<any>[];
